<!--
 * @Description: 主题色
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div class="bi-tmpl-detail__right__cmpt__title">
      {{ curItem.title }}
    </div>
    <div class="bi-tmpl-detail__right__cmpt-themeColor">
      <div
        class="bi-tmpl-detail__right__cmpt-themeColor__item"
        v-for="item in THEME_MAPPING"
        :key="item.value"
      >
        <BaseRadio
          class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w35"
          :value="item.value"
          :model-value="curItem.value"
          @click="onChange(item.value)"
        >
          <div
            :style="{
              background: item.color,
              width: '18px',
              height: '18px',
              'border-radius': '2px'
            }"
          ></div>
        </BaseRadio>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const CHILD_KEY = '101_1';
const THEME_MAPPING = {
  1: {
    color: '#265BA6',
    value:
      '#265BA6,#5BA1D5,#4E56BA,#4EB99C,#6B4EBA,#A44EB9,#9D7CF5,#9BAF65,#3D8D93,#D1A734'
  },
  2: {
    color: '#96643C',
    value:
      '#96643C,#A56190,#9989C4,#98B28C,#C78E60,#6C87CE,#BEA862,#5FAF8A,#69B6D3,#3B88B4'
  },
  3: {
    color: '#A51F08',
    value:
      '#A51F08,#5884BA,#D3B354,#7474B9,#45479B,#04057B,#C288CC,#61A8A3,#96643C,#1669E0'
  },
  4: {
    color: '#7457AC',
    value:
      '#7457AC,#D98F69,#C288CC,#54A8C7,#9498EA,#A754A7,#3D8D93,#D5B970,#94B172,#45479B'
  },
  5: {
    color: '#BEA862',
    value:
      '#BEA862,#DB9854,#9BAF65,#BE7BBE,#6A9DC9,#76BA81,#A44EB9,#265BA6,#7463D3,#96643C'
  },
  6: {
    color: '#3B88B4',
    value:
      '#3B88B4,#7463D3,#B76EC1,#70AF7C,#D5A75E,#61A8A3,#888BD0,#4E56BA,#10CBCB,#FFA767'
  },
  7: {
    color: '#3D8D93',
    value:
      '#3D8D93,#DDB13A,#617FD0,#78B58B,#9779CE,#AAB74A,#888BD0,#4E56BA,#10CBCB,#8247C6'
  },
  8: {
    color: '#6666BE',
    value:
      '#6666BE,#5DB0BF,#8E5DBF,#CCB462,#6DB583,#E0974E,#888BD0,#A3C100,#96643C,#10CBCB'
  },
  9: {
    color: '#5FAF8A',
    value:
      '#5FAF8A,#D5B970,#C28CCB,#69B6D3,#888BD0,#E2A364,#3D8D93,#265BA6,#AAB74A,#9B4E83'
  },
  10: {
    color: '#D1A734',
    value:
      '#D1A734,#94B172,#9B6DD9,#7070DB,#6794CB,#45B7B7,#4E56BA,#96643C,#B94EB9,#D17F2B'
  }
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
<style lang="scss" scoped>
.bi-tmpl-detail__right__cmpt {
  &-themeColor {
    height: 80px;
    border: 1px solid #e8e8e8;
    display: flex;
    justify-content: space-around;
    align-items: center;
    &__item {
      border-left: 1px solid #ebebeb;
      width: 100%;
      text-align: center;
    }
  }
}
</style>
